var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "14 15 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M27.75 17.667h7.303V35H14V17.667h7.303A3.267 3.267 0 0 1 24.526 15a3.267 3.267 0 0 1 3.224 2.667zm-3.224-1.334c-.888 0-1.612.567-1.875 1.334h3.75c-.263-.8-.987-1.334-1.875-1.334zM33.736 19h-18.42v8.5h18.42V19zm-18.42 14.667h18.42v-4.834h-18.42v4.834zm9.21-7.334a.894.894 0 0 1-.888-.9c0-.497.398-.9.888-.9s.888.403.888.9-.397.9-.888.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddJobs);
export default __webpack_public_path__ + "static/media/add-jobs.266723797400647b250c937be3eb1bf2.svg";
export { ForwardRef as ReactComponent };